// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-inset .em-zoom-buttons {
    display: none;
}
.em-inset-title {
    font-size: 11px;
}
.em-inset-subtitle {
    font-size: 12px;
}
.em-insets .em-frame {
    /* this will give a frame to inset maps */
    stroke: grey;
    stroke-width: 0.3px !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/insets.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,yCAAyC;IACzC,YAAY;IACZ,8BAA8B;AAClC","sourcesContent":[".em-inset .em-zoom-buttons {\r\n    display: none;\r\n}\r\n.em-inset-title {\r\n    font-size: 11px;\r\n}\r\n.em-inset-subtitle {\r\n    font-size: 12px;\r\n}\r\n.em-insets .em-frame {\r\n    /* this will give a frame to inset maps */\r\n    stroke: grey;\r\n    stroke-width: 0.3px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
